/* ══════════════════════════════════════════════════════════════════════
   Skön Cosmetics — skon-handle-map.js
   asset: assets/skon-handle-map.js

   Aggiornato: 15 luglio 2026 — 18:43 (Europe/Rome) — Versione 1.2

   v1.2 (15 lug 2026): + SKON_NO_QUIZ_PRODUCTS e SkonQuizExcluded() in fondo al
   file — esclusione di prodotti dalle CTA di invito al quiz. Vedi il blocco
   commentato in coda: è l'unico punto da modificare per aggiungere/togliere
   prodotti. Letti da nc-experience.js v2.9.2 e skon-fs-onboarding.js v2.4.0.

   ⚠️ NON è la fonte di verità unica, per quanto l'intestazione lo dichiarasse.
   Gli handle esistono in DUE posti:
     • window.SkonRoutine (skon-quiz-logic-data.js) → usato da skon-quiz.js
       (`getCatalogProduct(id).handle`) e quindi da result page ed EMAIL;
     • questa mappa → usata da nc-experience.js e skon-protocol-widget.js.
   Il 9 lug 2026 le due fonti erano divergenti: l'email mandava a Stay Soft
   Comfort Cream, il widget mostrava e vendeva la "Crema nutriente" del 2021.

   DA FARE: derivare questa mappa da SkonRoutine (che è caricato PRIMA di
   nc-experience in theme.liquid) invece di mantenerla in parallelo. Finché
   esistono due liste, una delle due resterà indietro — è già successo.

   Mappatura ID catalogo → handle Shopify.
   Usato da: nc-experience.js, skon-protocol-widget.js.
   (skon-quiz.js NON la usa: legge gli handle da SkonRoutine.)

   MANUTENZIONE:
   - Se Shopify cambia l'handle di un prodotto: aggiorna il valore a destra
   - Se aggiungi un prodotto al catalogo quiz: aggiungi una riga in CATALOG_IDS
   - L'ID catalogo (chiave) non cambia mai — è l'ID logico interno di Skön
   - L'handle (valore) è lo slug URL Shopify: /products/[handle]

   DEPLOYMENT (verificato 24 mag 2026): caricato da theme.liquid (asset
   globale, posizione 3) PRIMA di nc-experience.js e degli skon-fs-*.
   NB: in quiz-main.liquid NON è caricato — il quiz risolve gli handle per
   altra via. Caricato anche, su richiesta, dal liquid del protocol-widget
   se assente (auto-fallback). Usato da: nc-experience.js, skon-identity.js
   (indirettamente), skon-protocol-widget.js e dal Worker Magnews lato server.
══════════════════════════════════════════════════════════════════════ */

window.SKON_HANDLE_MAP = {

  /* ── CLEAN ME UP ─────────────────────────────────────────────────── */
  cmu_mousse:               'mousse-detergente',
  cmu_gel:                  'gel-detergente',
  cmu_balm:                 'burro-detergente-struccante',
  cmu_oil:                  'olio-detergente-struccante',
  cmu_eyes:                 'struccante-occhi-bifasico',
  cmu_essence:              'essenza-idratante-antiossidante',

  /* ── IMPERFECT ME ────────────────────────────────────────────────── */
  imperfect_gel_cleanser:   'imperfect-me-gel-detergente-anti-imperfezioni',
  imperfect_exfol:          'imperfect-me-lozione-esfoliante',
  imperfect_cream:          'imperfect-me-crema-viso-anti-imperfezioni',

  /* ── SIERI PRO-AGING ────────────────────────────────────────────── */
  iceland_breeze:           'siero-antieta-peptidi',
  better_late:              'siero-bakuchiol-antirughe',
  bakuplex_serum:           'bakuchiol-serum-viso-anti-age-bakuplex',
  siero_rimpolpante:        'siero-antieta-rimpolpante',

  /* ── SIERI IDRATAZIONE ──────────────────────────────────────────── */
  arctic_waterfalls:        'siero-viso-acido-ialuronico-puro',

  /* ── CONTORNO OCCHI ─────────────────────────────────────────────── */
  siero_contorno_occhi:     'siero-contorno-occhi-lifting-naturale',
  fy_eye_cream:             'forever-young-contorno-occhi-levigante-rimpolpante',
  /* FIX 10 lug 2026 — mancava del tutto: `isInProtocol` era sempre falso per
     questo prodotto e il widget non lo riconosceva. L'assenza era già annotata
     in skon-quiz-logic-data (v1.2.0) e mai colmata. Verificato live. */
  staysoft_eye:             'stay-soft-gel-contorno-occhi-idratante-lenitivo',
  crema_contorno_occhi:     'crema-contorno-occhi',

  /* ── SIERI PURIFICANTI ──────────────────────────────────────────── */
  siero_imperfezioni:       'siero-anti-impefezioni',
  patch_brufoli:            'patch-brufoli',

  /* ── CREME PRO-AGING ────────────────────────────────────────────── */
  forever_young_cream:      'forever-young-crema-viso-levigante-rimpolpante',
  old_forever_young:        'crema-viso-antirughe',
  bakuplex_crema_viso:      'bakuchiol-crema-viso-anti-age-bakuplex',
  wake_up_skin:             'crema-viso-notte',

  /* ── CREME IDRATAZIONE ──────────────────────────────────────────── */
  /* FIX 10 lug 2026 — era 'crema-nutriente-pelle-secca': è un PRODOTTO DIVERSO
     (la vecchia "Crema nutriente", pubblicata nel 2021 e tuttora ACTIVE), non
     un handle morto. Il widget protocollo e nc-experience mostravano e
     aggiungevano al carrello il prodotto sbagliato, a un prezzo diverso da
     quello promesso nell'email. Corretto in skon-quiz-logic-data v1.2.0 e mai
     riportato qui. Verificato live su Shopify. */
  staysoft_cream:           'stay-soft-crema-viso-nutriente-lenitiva',
  crema_idratante:          'crema-viso-idratante',
  crema_rossori:            'crema-rossori-rosacea-couperose',

  /* ── CREME LUMINOSITÀ ───────────────────────────────────────────── */
  vitamin_blast:            'crema-viso-alla-vitamina-c',
  over_the_moon:            'crema-viso-macchie',

  /* ── CREME PURIFICANTI ──────────────────────────────────────────── */
  crema_opacizzante:        'crema-viso-opacizzante-matt',
  maschera_purificante:     'maschera-viso-purificante',

  /* ── SPF / MAKE-UP ──────────────────────────────────────────────── */
  ak_glow:                  'abrakadabra-siero-viso-fondotinta-illuminante-con-protezione-solare',
  ak_matt:                  'abrakadabra-siero-viso-fondotinta-opacizzante-con-protezione-solare',
  fluido_spf:               'fluido-viso-protezione-solare',
  cc_cream:                 'cc-cream',

  /* ── INTEGRATORI ────────────────────────────────────────────────── */
  booster_collagene:        'integratore-collagene-vegano',

};


/* ══════════════════════════════════════════════════════════════════════
   PRODOTTI IN CATALOGO SHOPIFY NON ANCORA NEL QUIZ
   Commentati — aggiungere voce in SKON_HANDLE_MAP e in CATALOG
   di skon-quiz.js quando vengono inseriti nel flusso diagnostico.
══════════════════════════════════════════════════════════════════════

  // SPF aggiuntivi (non nel quiz attuale)
  // fluido_spf50:          'fluido-con-alta-protezione-solare-spf50',
  // stick_spf50:           'stick-con-alta-protezione-solare-spf50',

  // Prodotti corpo (fuori scope quiz viso)
  // bakuplex_crema_corpo:  'bakuchiol-crema-corpo-rimodellante-bakuplex',
  // bakuplex_scrub_corpo:  'bakuchiol-scrub-corpo-bakuplex',

  // Hair care (fuori scope quiz viso)
  // lozione_anticaduta:    'lozione-anti-caduta-growth-essence',
  // maschera_anticaduta:   'maschera-rinforzante-growth-essence',
  // lozione_colore:        'lozione-idratante-ravvivante-del-colore',
  // olio_colore:           'olio-nutriente-ravvivante-del-colore',

  // Accessori / altro
  // gel_detergente_delicato: 'gel-detergente-delicato',  // variante delicata cmu_gel?
  // fluido_riparatore:     'fluido-riparatore-con-pantenolo-al-5',
  // crema_gambe:           'crema-defaticante-gambe-legs-go',
  // crema_mani:            'crema-mani-riparatrice',
  // lip_plumper:           'lip-plumper-volumizzante-labbra',
  // olio_labbra:           'olio-labbra-nutriente',

*/
/* ══════════════════════════════════════════════════════════════════════
   v1.2 (15 lug 2026) — ESCLUSIONE PRODOTTI DALLE CTA QUIZ
   ══════════════════════════════════════════════════════════════════════
   Elenco dei prodotti la cui PDP NON deve mostrare ALCUN invito a compilare
   il quiz. Superfici soppresse (tutte e sole quelle che INVITANO):
     • strip contestuale PDP            (nc-experience _renderStrip)
     • link "Trova la tua routine" ATC  (nc-experience _renderQuizLinkAfterATC)
     • exit-intent                      (nc-experience _showExitSheet)
     • popup identità NC/RC             (skon-fs-onboarding shouldShow)

   NON tocca le superfici che mostrano il RISULTATO a chi una routine ce l'ha
   già (price-note, badge protocollo, sticky bar, protocol-widget): quelle non
   invitano a nulla, dicono solo quanto paghi davvero col tuo codice.

   Perché esiste: su certe pagine l'invito al quiz non fidelizza, serve solo a
   far scaricare l'extra-sconto. Caso d'origine (15 lug 2026): l'integratore
   collagene ha una campagna Meta dedicata molto efficace, ma NON è mai un
   prodotto CORE di nessuna delle 28 routine (è un tip in 16/28) — quindi il
   widget non lo mostrerà mai fra i 4 prodotti della routine.

   ── COME SI USA ──────────────────────────────────────────────────────
   Ogni voce può essere, indifferentemente:
     • un ID CATALOGO presente in SKON_HANDLE_MAP qui sopra → 'booster_collagene'
       ↑ CONSIGLIATO: se l'handle cambia su Shopify si aggiorna solo la mappa,
         in un punto solo, e l'esclusione continua a funzionare.
     • un HANDLE o un suo FRAMMENTO                          → 'kit-natale-2026'

   Il confronto è per SOTTOSTRINGA sull'handle della PDP corrente: una voce
   prende quindi anche i BUNDLE che contengono quell'handle. Esempio reale:
     'booster_collagene' → frammento 'integratore-collagene-vegano' → prende
     sia 'integratore-collagene-vegano' (PDP singola)
     sia 'collagen-elixir-integratore-collagene-vegano-double-pack' (bundle).
   ⚠️ Corollario: usare frammenti SPECIFICI. Una voce 'crema' prenderebbe TUTTE
   le creme. Nel dubbio, usare l'ID catalogo.

   Per DISATTIVARE l'esclusione: svuotare l'array (`= []`). Se questo file non
   carica, il matcher non esiste e le guardie falliscono APERTE (gli inviti si
   vedono, come prima): nessun rischio di sparizioni silenziose.
══════════════════════════════════════════════════════════════════════ */
window.SKON_NO_QUIZ_PRODUCTS = [
  'booster_collagene',   // Booster del Collagene (+ bundle "Routine 48 Giorni") — campagna Meta, mai core di una routine
];

/* Ritorna true se la pagina corrente è la PDP di un prodotto escluso dalle CTA
   quiz. Letta a RUNTIME (non alla definizione) da nc-experience.js e
   skon-fs-onboarding.js → l'array qui sopra è l'UNICO punto da modificare.
   Fuori dalle PDP ritorna sempre false. */
window.SkonQuizExcluded = function() {
  try {
    var parts = window.location.pathname.split('/products/');
    if (parts.length < 2) return false;                    // non è una PDP
    var handle = parts[1].split('/')[0].split('?')[0].toLowerCase();
    if (!handle) return false;
    var list = window.SKON_NO_QUIZ_PRODUCTS || [];
    for (var i = 0; i < list.length; i++) {
      var raw = list[i];
      if (!raw) continue;
      // ID catalogo → risolto via SKON_HANDLE_MAP; altrimenti la voce È già un handle/frammento
      var mapped   = window.SKON_HANDLE_MAP && window.SKON_HANDLE_MAP[raw];
      var fragment = String(mapped || raw).trim().toLowerCase();
      if (fragment && handle.indexOf(fragment) !== -1) return true;
    }
  } catch (e) {}
  return false;
};